import { httpGet, httpPost, httpPatchMerge, httpDelete } from '../http'
import type { ILeadSourceContact } from '~/types/contact/models'
import type { TEntityId } from '~/types/models'
import { Contact } from '~/cynqueModules/dataObjects/Contact'

const apiEntityPath = '/api/leadsourcecontacts'

export async function getLeadSourceContacts({ apiPath = apiEntityPath } = {}) {
  const callingMn = getLeadSourceContacts.name
  return httpGet<ILeadSourceContact[]>({ callingMn, apiPath })
}

export async function getLeadSourceContactsPreProcessed({
  apiPath = apiEntityPath,
} = {}) {
  const callingMn = getLeadSourceContacts.name
  const rawLeadSourceContacts = await httpGet<ILeadSourceContact[]>({
    callingMn,
    apiPath,
  })
  return rawLeadSourceContacts.map((rawLeadSourceContact) =>
    Contact(rawLeadSourceContact)
  )
}

export async function createLeadSourceContact(entity: ILeadSourceContact) {
  const callingMn = createLeadSourceContact.name
  const apiPath = apiEntityPath
  return httpPost<ILeadSourceContact>({ callingMn, apiPath, entity })
}

export async function updateLeadSourceContact(
  entityData: Partial<ILeadSourceContact>,
  id: TEntityId
) {
  const callingMn = updateLeadSourceContact.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialILeadSourceContact = Partial<ILeadSourceContact>
  return httpPatchMerge<TPartialILeadSourceContact>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteLeadSourceContact(entityData: ILeadSourceContact) {
  const callingMn = deleteLeadSourceContact.name
  const apiPath = apiEntityPath
  return httpDelete<ILeadSourceContact>({
    callingMn,
    apiPath,
    entityData,
  })
}
